export const errorStyles = {
  border: "2px solid #cc3300",
};
